import styled from 'styled-components';

export const StyledSuccessContent = styled.div`
  text-align: center;
  padding: 8px 0;

  .flow-success-checkmark {
    margin-bottom: 16px;

    @keyframes successCheckmark {
      0% {
        transform: scale(0.8);
        opacity: 0;
      }
      100% {
        transform: scale(1);
        opacity: 1;
      }
    }

    animation: successCheckmark 0.4s ease-out;
    svg {
      font-size: 64px;
      color: #52c41a;
    }
  }

  h3 {
    margin: 0 0 8px;
    font-size: 18px;
    font-weight: 600;
  }

  p {
    margin: 0 0 24px;
    color: rgba(0, 0, 0, 0.65);
  }
`;
